import { isEmpty } from 'lodash';
// import ShellClient from '../../clients/ShellClient';
import ShellIHubModel from '@/models/ShellIHubModel';
import ShellPartnersModel from '@/models/ShellPartnersModel';

function transformShellIHubResponse(response) {
  if (!isEmpty(response)) {
    const { data: responseData } = response;
    return new ShellIHubModel({ ...responseData });
  }
  return null;
}

function transformPartnersResponse(response) {
  if (!isEmpty(response)) {
    const { data: responseData } = response;
    return new ShellPartnersModel([...responseData]);
  }
  return null;
}

export default {
  transformShellIHubResponse,
  transformPartnersResponse,
};
